import { CLICK } from '@updater-core/lib/tracker';
import { copyTextToClipboard } from '../../utils';

export const redeem = (promotion, copy = true) => {
  if (copy && promotion.code) {
    copyCode(promotion.promotionCode);
  }
};

export const copyCode = (promotionCode) => {
  copyTextToClipboard(promotionCode);
};

export const trackRedeem = (tracker, promotion, sourceId = '') => {
  const details = {
    sourceId,
    promotionId: promotion.promotionId,
    claimedId: promotion.claimedId,
    link: promotion.link,
    entityId: promotion.entityId,
    entityName: promotion.entityName,
    code: promotion.code,
    promotionCode: promotion.promotionCode,
  };

  tracker.track({
    verb: CLICK,
    object: 'redeem',
    details,
  });
  tracker.track({
    verb: CLICK,
    object: 'link_out',
    details,
  });
};

export const trackCopyToClipboard = (tracker) => {
  tracker.track({
    verb: CLICK,
    domain: 'promotions',
    object: 'copy_to_clipboard',
    details: {
      source: 'exclusive_offers',
    },
  });
};
